import React from "react";
import { Card } from "react-bootstrap";
import "../assets/styles/TestimonialCarousel.scss";

const testimonials = [
  {
    id: 1,
    title: "Confident Blood Sugar",
    subtitle: "Diabetes Management",
    content:
      "I didn’t expect it to be this helpful. Being able to speak with a certified dietitian virtually made managing my diet much easier. I’ve seen real improvements in my blood sugar.",
  },
  {
    id: 2,
    title: "Practical, Ongoing Support",
    subtitle: "Diabetes Management",
    content:
      "I really appreciate how practical the advice was. The nutritionist tailored everything to my condition, and the ongoing support kept me motivated and stay on track.",
  },
  {
    id: 3,
    title: "Personalised Nutrition Guidance",
    subtitle: "Diabetes Management",
    content:
      "The guidance felt truly personal. I could ask questions anytime and receive clear, professional advice, which helped me make better food choices every day.",
  },
  {
    id: 4,
    title: "Better Diabetes Control",
    subtitle: "Diabetes Management",
    content:
      "At first, I was confused about my diet and thought medication alone was enough to control my blood sugar. With the dietitian’s guidance, everything became much clearer. The tips were simple and easy to follow—really helpful.",
  },
  {
    id: 5,
    title: "Slowly But Surely",
    subtitle: "Diabetes Management",
    content:
      "Thanks to my coach’s advice and encouragement, I’ve already started paying more attention to my calorie intake and meal choices, and I’ve already dropped from 102kg to 99kg! Exercise is still a challenge for me but I’m taking it one step at a time and will keep sharing my progress!",
  },
  {
    id: 6,
    title: "Former Sweet Tooth",
    subtitle: "Weight Management",
    content:
      "Alhamdulillah, my weight has gone down, especially after adding some light exercise to my routine. I’ve also cut back on sugary drinks now — having them only about once a week.  While I still enjoy the occasional cheat meal,  my water intake has been consistent. Even after Raya, I’ve managed to maintain my weight at 65.5kg.",
  },
  {
    id: 7,
    title: "Determined BMI Chaser",
    subtitle: "Weight Management",
    content:
      "I’ve lost around 4kg and I’m really proud! With coach‘s guidance, I’m learning  to make smarter choices and stay on track. I’m working towards  a healthier BMI, and while  the journey continues, I'm more motivated than ever to keep going.",
  },
  {
    id: 8,
    title: "Morning Jogger in Progress",
    subtitle: "Exercise Posture",
    content:
      "I used to struggle with stiffness while jogging, but after adjusting my posture with  tips from Coach tips, things have really improved! I’m feeling more confident and comfortable during my runs now.",
  },
];

const TestimonialCarousel = () => {
  return (
    <section className="testimonial">
      {/* <div className="title-container"> */}
      <div className="title-row text-start py-lg-4 py-2">
        {" "}
        Real Stories, Real Progress
      </div>
      {/* </div> */}
      <div className="testimonial-scroll-wrapper">
        <div className="testimonial-scroll">
          {testimonials.map((t) => (
            <Card className="carousel-card me-3" key={t.id}>
              <Card.Body>
                <blockquote>
                  <div className="testimonial-title">{t.title}</div>
                  <div className="testimonial-subtitle">{t.subtitle}</div>
                </blockquote>
                <div className="testimonial-content">"{t.content}"</div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
